define([
    "./menuCommonsModule",
    "./menuCommonsService"], function () {
});